<div class="bookmark-popup">
    <button class="close-button" (click)="closePopup()">✖</button>
    <div class="icon-container">
        <img src="../../../../../assets/images/lock.png" alt="Lock Image" width="49px" height="62px"/>
    </div>
    <p class="popup-message" [innerHTML]="message" ></p>
    <button class="watchlist-button" (click)="buyPass()">Buy Pass</button>
</div>
